import { FC } from 'react';

const IconFlights: FC = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
			<g opacity="0.7">
				<path
					d="M3.8998 15.5499L4.6248 14.8249L7.1248 15.1749L11.5248 10.7499L3.2998 6.2749L4.2748 5.2999L14.3248 7.8749L18.5248 3.7499C18.7581 3.51657 19.0498 3.3999 19.3998 3.3999C19.7498 3.3999 20.0415 3.51657 20.2748 3.7499C20.5081 3.98324 20.6248 4.2749 20.6248 4.6249C20.6248 4.9749 20.5081 5.26657 20.2748 5.4999L16.1248 9.6749L18.6998 19.7499L17.7248 20.6999L13.2498 12.4749L8.8498 16.8999L9.1998 19.3999L8.4748 20.1249L6.8498 17.1749L3.8998 15.5499Z"
					fill="white"
				/>
			</g>
		</svg>
	);
};
export default IconFlights;
